import React from "react";
import { Button, Icon, Modal } from "@plum-xoxo/admin-dsm";
import InputCode from "./InputCode";
import WrongOTPModal from "./wrongOtpModal";
import styled from "styled-components";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import theme from "../../../theme/theme";
import { Turnstile } from "@plum-xoxo/turnstile_captcha";
import { TURNSTILE_SITE_KEY } from "../../../constants/AppConstant";

const HeadingTypography = styled(Typography.H2).attrs()`
  color: ${(props) => props.theme.palette.dark.c300};
`;
const StyledModal = styled(Modal).attrs()`
  max-width: 478px;
`;
const EmailText = styled.div`
  color: ${(props) => props.theme.palette.dark.c300};
  font-size: 14px;
`;

const BlueText = styled.div`
  color: ${(props) => props.theme.palette.primary.c03};
`;

const AnchorTag = styled.div`
  color: ${(props) => props.theme.palette.primary.c03};
`;

const EnterOTPTextTypography = styled(Typography).attrs()`
  font-size: 12px;
  line-height: 16px;
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  margin: 2px;
  color: ${(props) => props.theme.palette.dark.c300};
`;

const OtpResendText = styled(Typography).attrs()`
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

class SecondStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: {},
      seconds: 60,
      setLoading: false,
      loading: false,
      otp: {},
      resendClicked: false,
      renderTurnstileCaptcha: false,
    };
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  }

  startTimer(token = "") {
    const { resendClicked } = this.state;
    if (resendClicked) {
      this.props.resendOTP(token);
      this.setState({ renderTurnstileCaptcha: false });
      if (this.state.seconds > 0) {
        this.timer = setInterval(this.countDown, 1000);
      }
    }
  }

  countDown() {
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    if (seconds < 0) {
      this.setState({ time: {}, seconds: 60, resendClicked: false });
      clearInterval(this.timer);
    }
  }

  render() {
    const { error, OTP, currentStep, backCurrentStep, showCts } = this.props;
    const { time, renderTurnstileCaptcha } = this.state;
    return (
      <div className={`${currentStep === 2 ? "" : "display-none"}`}>
        <StyledModal
          isOpen={currentStep === 2}
          size="md"
          style={{
            maxWidth: "478px",
          }}
          className="step-two-modal p-24"
          onClose={() => {
            backCurrentStep(false);
          }}
        >
          <div className="sign-up">
            <div className="rightContainer">
              <div className="step-two">
                <div className="content">
                  <div className="verify-email-wrapper">
                    <HeadingTypography>Verify your Email</HeadingTypography>
                    <div
                      className="cursor-pointer"
                      onClick={() => backCurrentStep(false)}
                    >
                      <img src="/admin/img/icons/cross.svg" />
                    </div>
                  </div>
                  <div className="email-container">
                    <div>
                      <Typography
                        color="dark"
                        shade="c200"
                        style={theme.typography.label}
                        className="mb-1"
                      >
                        Email address
                      </Typography>
                      <EmailText>{this.props.email}</EmailText>
                    </div>
                    <Button
                      variant="plain"
                      onClick={() => backCurrentStep(true)}
                    >
                      Change
                    </Button>
                  </div>

                  <Typography className="mb-2">
                    <Typography.ButtonText
                      color="dark"
                      shade="c300"
                      component="span"
                    >
                      Thanks for signing up.{" "}
                    </Typography.ButtonText>
                    An account verification email has been sent to your email{" "}
                    <Typography.ButtonText
                      color="dark"
                      shade="c300"
                      component="span"
                    >
                      {this.props.email}
                      {". "}
                    </Typography.ButtonText>
                    Please enter the
                    <Typography.ButtonText
                      color="dark"
                      shade="c300"
                      component="span"
                    >
                      {" "}
                      6 digit verification code{" "}
                    </Typography.ButtonText>
                    to complete your registration.
                  </Typography>
                  <Typography className="mt-20" color="dark" shade="c200">
                    Please check your spam or junk folder just in case the email
                    got delivered there
                  </Typography>
                  <form>
                    <EnterOTPTextTypography className="mt-32">
                      Enter Code
                    </EnterOTPTextTypography>
                    <Typography
                      component="div"
                      className="otpInput mt-16 mb-16 d-block"
                    >
                      <InputCode
                        length={6}
                        label="Code Label"
                        loading={this.state.loading}
                        onComplete={(code) => this.props.onOtpChange(code)}
                        otp={this.props.OTP}
                      />
                    </Typography>
                    {error["invalid_otp"] ? (
                      <div>{error["invalid_otp"]}</div>
                    ) : null}
                    {Object.keys(time).length && !error["invalid_otp"] ? (
                      <Typography
                        component="div"
                        className="align-items-center d-flex mt-0"
                      >
                        <Typography component="div">
                          <Icon
                            color="green"
                            shade="c300"
                            iconName="Right"
                            size="m"
                          />
                        </Typography>
                        <Typography
                          className="ml-8"
                          component="span"
                          color="green"
                          shade="c300"
                        >
                          A new Code has been sent to{" "}
                          <Typography.ButtonText component="span">
                            {this.props.email}
                          </Typography.ButtonText>
                        </Typography>
                      </Typography>
                    ) : null}
                    <div className="step-two-button-container">
                      <div className="cursor-pointer">
                        {Object.keys(time).length ? (
                          <OtpResendText
                            color="dark"
                            shade="c200"
                            className="m-0"
                          >
                            Resend Code in {time.s} seconds(s)
                          </OtpResendText>
                        ) : (
                          <>
                            {renderTurnstileCaptcha ? (
                              <Turnstile
                                siteKey={TURNSTILE_SITE_KEY}
                                onSuccess={(token) => {
                                  this.setState({ resendClicked: true }, () =>
                                    this.startTimer(token)
                                  );
                                }}
                                options={{ theme: "light" }}
                                style={{ width: "100%" }}
                              />
                            ) : (
                              <Typography.ButtonText>
                                <BlueText>
                                  <AnchorTag
                                    onClick={() => {
                                      if (showCts) {
                                        this.setState({
                                          renderTurnstileCaptcha: true,
                                        });
                                      } else {
                                        this.setState(
                                          { resendClicked: true },
                                          () => this.startTimer()
                                        );
                                      }
                                    }}
                                  >
                                    Resend Code
                                  </AnchorTag>
                                </BlueText>
                              </Typography.ButtonText>
                            )}
                          </>
                        )}
                      </div>
                      <Button
                        variant="fill"
                        onClick={(e) => (
                          e.preventDefault(),
                          !this.props.api_call
                            ? this.props.validOTpMail(e)
                            : null
                        )}
                        disabled={OTP.length != 6}
                        loading={this.props.api_call}
                      >
                        Verify Email
                      </Button>
                    </div>
                  </form>
                </div>
                {error["invalid_otp"] == "Wrong Code more than 3 time" ? (
                  <WrongOTPModal error={true} />
                ) : null}
              </div>
            </div>
          </div>
        </StyledModal>
      </div>
    );
  }
}

export default SecondStep;
